"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Checkbox } from "@nxt-costco-com/forge-components";
import * as Icons from "@nxt-costco-com/forge-icons";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { StyledLabel } from "./styles.js";
const WarehouseOptionCheckbox = ({
  isChecked,
  onChange,
  option,
  uniqueId
}) => {
  if (!option) return null;
  const Icon = Icons[option.iconName];
  return /* @__PURE__ */ jsxs(
    CostcoBox,
    {
      sx: {
        "&:hover": {
          cursor: "pointer"
        },
        alignItems: "flex-start",
        display: "flex",
        width: "fit-content"
      },
      children: [
        /* @__PURE__ */ jsx(
          Checkbox,
          {
            id: option.id,
            isChecked,
            onChange,
            uniqueId
          },
          option.id
        ),
        /* @__PURE__ */ jsxs(StyledLabel, { htmlFor: option.id, children: [
          Icon && /* @__PURE__ */ jsx(
            Icon,
            {
              style: {
                height: "20px",
                width: "20px"
              }
            }
          ),
          " ",
          option.label
        ] })
      ]
    },
    option.id
  );
};
export {
  WarehouseOptionCheckbox
};
